import React from 'react'
import { SpreadsheetMapping, ColumnMapping } from 'api'
import {
  ColumnsContainer,
  ColumnsHeaderPanel,
  ColumnsHeader,
  ColumnMappingStringPanel,
  ColumnMappingDecimalPanel
} from '../upload/mappingDialog'
import { Locale, Translation } from 'locale'
import { CollateralAllocationParseResult } from './collateralBasketAllocationUploadParse'

export interface CollateralBasketAllocationMappingDialogColumnsProps {
  mapping: SpreadsheetMapping
  parseResult: CollateralAllocationParseResult
  onUpdate: (mapping: SpreadsheetMapping) => unknown
}

export const CollateralBasketAllocationMappingDialogColumns: React.FC<CollateralBasketAllocationMappingDialogColumnsProps> = props => {
  const { mapping, parseResult, onUpdate } = props

  const handleColumnUpdate = (columnMapping: ColumnMapping, fieldName: keyof SpreadsheetMapping) =>
    onUpdate({ ...mapping, [fieldName]: columnMapping })

  return (
    <ColumnsContainer>
      <ColumnsHeaderPanel>
        <ColumnsHeader>{Locale.translate(Translation.TC_COLLATERAL_BASKET_ALLOCATION_FIELD)}</ColumnsHeader>
        <ColumnsHeader>{Locale.translate(Translation.TC_SPREADSHEET_COLUMN)}</ColumnsHeader>
      </ColumnsHeaderPanel>

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_ISIN_BUI)}
        fieldName="isin"
        columnMapping={mapping.isin}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingDecimalPanel
        fieldTitle={Locale.translate(Translation.TC_NOTIONAL_SHORT)}
        fieldName="notional"
        columnMapping={mapping.notional}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_START_CONSIDERATION)}
        fieldName="startConsideration"
        columnMapping={mapping.startConsideration}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_ALL_IN_PRICE)}
        fieldName="allInPrice"
        columnMapping={mapping.allInPrice}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_HAIRCUT)}
        fieldName="haircut"
        columnMapping={mapping.haircut}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
    </ColumnsContainer>
  )
}
